import React from "react";
import FlipTile from "./FlipTile";

interface FlipGroupProps {
    value: string;
    label: string;
    color: string;
}

const FlipGroup: React.FC<FlipGroupProps> = (props) => {
    return (
        <div className="flex flex-col items-center gap-2">
            <div className="font-plot-roboto-mono text-[0.35em] uppercase tracking-wide text-plot-white">
                {props.label}
            </div>
            <div className="flex flex-row gap-2">
                {props.value.split("").map((digit, i) => (
                    <FlipTile key={i} digit={digit} color={props.color} />
                ))}
            </div>
        </div>
    );
};

export default FlipGroup;
